import styles from './ProductIllustration.module.css';

function GridPattern({ id }) {
  return (
    <>
      <defs>
        <pattern id={id} width="20" height="20" patternUnits="userSpaceOnUse">
          <path
            d="M 20 0 L 0 0 0 20"
            fill="none"
            stroke="currentColor"
            strokeWidth="0.5"
            opacity="0.15"
          />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill={`url(#${id})`} />
    </>
  );
}

function CodeSvg() {
  return (
    <svg viewBox="0 0 400 200" className={styles.svg}>
      <GridPattern id="grid-code" />
      <line x1="80" y1="20" x2="80" y2="180" stroke="currentColor" strokeWidth="3" strokeDasharray="4 4" />
      <circle cx="80" cy="50" r="8" fill="currentColor" />
      <circle cx="80" cy="100" r="8" fill="currentColor" />
      <circle cx="80" cy="150" r="8" fill="currentColor" />
      <path d="M 80 100 C 160 100, 160 50, 240 50" fill="none" stroke="currentColor" strokeWidth="3" />
      <circle cx="240" cy="50" r="8" fill="none" stroke="currentColor" strokeWidth="3" />
      <line x1="240" y1="50" x2="320" y2="50" stroke="currentColor" strokeWidth="3" strokeDasharray="4 4" />
      <rect x="312" y="42" width="16" height="16" fill="currentColor" />
      <path d="M 80 150 C 160 150, 160 150, 240 150" fill="none" stroke="currentColor" strokeWidth="3" />
      <circle cx="240" cy="150" r="8" fill="currentColor" />
    </svg>
  );
}

function AlignSvg() {
  return (
    <svg viewBox="0 0 400 200" className={styles.svg}>
      <GridPattern id="grid-align" />
      <rect x="60" y="40" width="80" height="30" fill="none" stroke="currentColor" strokeWidth="3" />
      <rect x="60" y="130" width="80" height="30" fill="none" stroke="currentColor" strokeWidth="3" />
      <path d="M 140 55 L 200 55 L 200 85 L 240 85" fill="none" stroke="currentColor" strokeWidth="3" />
      <path d="M 140 145 L 200 145 L 200 115 L 240 115" fill="none" stroke="currentColor" strokeWidth="3" />
      <rect x="240" y="70" width="100" height="60" fill="currentColor" />
      <line x1="290" y1="20" x2="290" y2="180" stroke="currentColor" strokeWidth="1" strokeDasharray="2 2" opacity="0.5" />
    </svg>
  );
}

function VerifySvg() {
  return (
    <svg viewBox="0 0 400 200" className={styles.svg}>
      <GridPattern id="grid-verify" />
      <rect x="40" y="80" width="40" height="40" fill="none" stroke="currentColor" strokeWidth="3" />
      <line x1="80" y1="100" x2="140" y2="100" stroke="currentColor" strokeWidth="2" strokeDasharray="4 4" />
      <rect x="140" y="60" width="40" height="80" fill="currentColor" />
      <line x1="180" y1="100" x2="240" y2="100" stroke="currentColor" strokeWidth="2" strokeDasharray="4 4" />
      <rect x="240" y="80" width="40" height="40" fill="none" stroke="currentColor" strokeWidth="3" />
      <circle cx="260" cy="100" r="8" fill="currentColor" />
      <line x1="280" y1="100" x2="340" y2="100" stroke="currentColor" strokeWidth="2" strokeDasharray="4 4" />
      <polygon points="340,90 360,100 340,110" fill="currentColor" />
      <rect x="55" y="140" width="10" height="10" fill="currentColor" />
      <rect x="155" y="150" width="10" height="10" fill="currentColor" />
      <rect x="255" y="140" width="10" height="10" fill="none" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}

function DeliverSvg() {
  return (
    <svg viewBox="0 0 400 200" className={styles.svg}>
      <GridPattern id="grid-deliver" />
      <path d="M 40 100 L 300 100" fill="none" stroke="currentColor" strokeWidth="3" />
      <polygon points="300,85 330,100 300,115" fill="currentColor" />
      <rect x="120" y="40" width="80" height="120" fill="#EBEFEA" stroke="currentColor" strokeWidth="3" />
      <rect x="140" y="55" width="80" height="120" fill="#EBEFEA" stroke="currentColor" strokeWidth="3" />
      <rect x="160" y="70" width="80" height="120" fill="currentColor" />
      <circle cx="280" cy="100" r="20" fill="none" stroke="#EBEFEA" strokeWidth="3" strokeDasharray="4 4" />
    </svg>
  );
}

function ObserveSvg() {
  return (
    <svg viewBox="0 0 400 200" className={styles.svg}>
      <GridPattern id="grid-observe" />
      <line x1="40" y1="160" x2="360" y2="160" stroke="currentColor" strokeWidth="3" />
      <line x1="40" y1="160" x2="40" y2="40" stroke="currentColor" strokeWidth="3" />
      <rect x="70" y="110" width="24" height="50" fill="currentColor" />
      <rect x="110" y="80" width="24" height="80" fill="currentColor" />
      <rect x="150" y="130" width="24" height="30" fill="none" stroke="currentColor" strokeWidth="3" />
      <rect x="190" y="50" width="24" height="110" fill="currentColor" />
      <rect x="230" y="90" width="24" height="70" fill="currentColor" />
      <rect x="270" y="70" width="24" height="90" fill="none" stroke="currentColor" strokeWidth="3" />
      <path d="M 90 90 L 130 60 L 170 110 L 210 30 L 250 70 L 290 50" fill="none" stroke="currentColor" strokeWidth="2" strokeDasharray="4 4" />
      <circle cx="210" cy="30" r="6" fill="#EBEFEA" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}

function OperateSvg() {
  return (
    <svg viewBox="0 0 400 200" className={styles.svg}>
      <GridPattern id="grid-operate" />
      <line x1="0" y1="100" x2="400" y2="100" stroke="currentColor" strokeWidth="1" strokeDasharray="2 4" opacity="0.5" />
      <line x1="200" y1="0" x2="200" y2="200" stroke="currentColor" strokeWidth="1" strokeDasharray="2 4" opacity="0.5" />
      <path d="M 0 100 L 120 100 L 150 40 L 180 160 L 210 80 L 230 100 L 400 100" fill="none" stroke="currentColor" strokeWidth="3" strokeLinejoin="miter" />
      <circle cx="150" cy="40" r="16" fill="none" stroke="currentColor" strokeWidth="2" />
      <line x1="150" y1="10" x2="150" y2="25" stroke="currentColor" strokeWidth="2" />
      <line x1="150" y1="55" x2="150" y2="70" stroke="currentColor" strokeWidth="2" />
      <line x1="120" y1="40" x2="135" y2="40" stroke="currentColor" strokeWidth="2" />
      <line x1="165" y1="40" x2="180" y2="40" stroke="currentColor" strokeWidth="2" />
      <circle cx="150" cy="40" r="4" fill="currentColor" />
    </svg>
  );
}

const ILLUSTRATIONS = {
  code: CodeSvg,
  align: AlignSvg,
  verify: VerifySvg,
  deliver: DeliverSvg,
  observe: ObserveSvg,
  operate: OperateSvg,
};

export default function ProductIllustration({ productId, figure }) {
  const Illustration = ILLUSTRATIONS[productId];
  if (!Illustration) return null;

  return (
    <div className={styles.illustration}>
      <Illustration />
      <span className={styles.figure}>{figure}</span>
    </div>
  );
}
